<template>
  <div>
    <b-card style="margin:1%">
      <b-col style="margin:5px">
        <b-button @click.stop="showFormGroups" variant="success">{{ $t('Add') }}</b-button>
      </b-col>
      <b-table small striped hover :items="groupsUser" :fields="fieldsGroups" @row-clicked="rowClickHandler">
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="deleteGroups(row)" id="transparent">
            <b-img :src='deleteDocumentImage' />
        </b-button>
        </template>
      </b-table>
    </b-card>

      <b-modal ref="addGroupsUser" hide-footer :title="$t('Groups')" @hidden="isShowGroupsUser = false">
        <FormAddGroup v-if="isShowGroupsUser" @hideFormGroups="hideFormGroups" @refresh="refresh" :userInfo="userInfo" :currentRow="currentRow" @makeToasts="makeToasts"></FormAddGroup>
      </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormAddGroup from './formAddGroup'

export default {
  components: {
    FormAddGroup
  },
  props: {
    currentRow: null,
    userInfo: null
  },
  data () {
    return {
      isShowGroupsUser: false,
      groups: null,
      addDocumentImage: require('@/assets/img/file_add.png'),
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      groupsUser: [],
      fieldsGroups: [
        { key: 'group_id', label: 'ID', sortable: true },
        { key: 'group_name', label: this.$i18n.t('Name'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      selectGroup: null
    }
  },
  methods: {
    async load () {
      this.groups = await axiosInstance.get(this.$store.getters.API_USERS_GROUPS).then(response => { return response.data })
      var groupsTable = JSON.parse(JSON.stringify(this.currentRow.groups))
      for (let i in groupsTable) {
        for (let j in this.groups) {
          if (this.groups[j].group_id === groupsTable[i]) {
            let groupsRow = {
              'group_id': groupsTable[i],
              'group_name': this.groups[j].group_name
            }
            groupsTable[i] = groupsRow
          }
        }
      }
      this.groupsUser = groupsTable
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    rowClickHandler (row) {
      if (this.selectGroup) {
        this.selectGroup._rowVariant = ''
      }
      this.selectGroup = row
      this.group_id = row.group_id
      this.$set(this.selectGroups, '_rowVariant', 'info')
    },
    deleteGroups (row) {
      this.selectGroup = row.item
      this.currentRow.groups = this.currentRow.groups.filter((value) => {
        return value !== this.selectGroup.group_id
      })
      this.load()
    },
    refresh () {
      this.load()
    },
    showFormGroups () {
      this.isShowGroupsUser = true
      this.$refs.addGroupsUser.show()
    },
    hideFormGroups () {
      this.isShowGroupsUser = false
      this.$refs.addGroupsUser.hide()
    }
  },
  watch: {
    currentRow: function (val) {
      this.load()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/groups/main.vue